// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


const configInfo = {
    routerBase:'/laurelsmobile/',
    Laurels_URL:"https://league.sportdata.cn/laurels",
    //Laurels_URL:"http://127.0.0.1:8080/laurels"
    orgCode:'',
    orgName:'',
    isAdvertisementShow:false
};


export default configInfo





// WEBPACK FOOTER //
// ./src/configInfo.js